// @material-ui/icons
import Flight from "@material-ui/icons/Flight";
import Settlement from "@material-ui/icons/Style";
import Passenger from "@material-ui/icons/AirlineSeatReclineExtra";
import Audit from "@material-ui/icons/TrackChanges";
import AirlineRouteIcon from "@material-ui/icons/Flight";
import Landing from "@material-ui/icons/FlightLandOutlined";
import Receipt from "@material-ui/icons/Receipt";

import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";

import NotFound from "views/NotFound/Index.jsx";

import AirlinesPassengerPage from "Regional-Views/AirlinesPassenger/Index.jsx";
import AirlinePaymentPage from "Regional-Views/AirlinePayment/Index.jsx";
import SettlementPage from "Regional-Views/Settlement/Index.jsx";
import OutstandingSettlementPage from "Regional-Views/OutstandingSettlement/Index.jsx";
import InvoiceApproval from "Regional-Views/InvoiceApproval/Index";
import ExchangeRateAirlineView from "Regional-Views/ExchangeRateAirline/airlineView.js";
import HelpCenter from "../Regional-Views/HelpCenter/index"
import HelpIcon from "@material-ui/icons/HelpOutline"

const dashboardRoutes = [
  {
    path: "/main-landing",
    sidebarName: "Main Landing",
    navbarName: "Main Landing",
    icon: Landing,
    component: MainLandingPage,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/passenger-data",
    sidebarName: "Passenger Data",
    navbarName: "Airline Passenger Data",
    icon: Passenger,
    subMenu: [],
    component: AirlinesPassengerPage
  },
  {
    path: "/app/psc-regional/airline-payment",
    sidebarName: "Airline Payment",
    navbarName: "Airline Payment Report",
    icon: Flight,
    subMenu: [],
    component: AirlinePaymentPage
  },
  {
    path: "/app/psc-regional/invoice-approval",
    sidebarName: " Payment Approval",
    navbarName: "Payment Approval",
    icon: Receipt,
    subMenu: [],
    component: InvoiceApproval
  },
  {
    path: "/app/psc-regional/psc-settlement",
    sidebarName: " PSC Settlement",
    navbarName: "PSC Settlement",
    icon: Settlement,
    subMenu: [],
    component: SettlementPage
  },
  {
    path: "/app/psc-regional/outstanding-settlement",
    sidebarName: "Outstanding Settlement",
    navbarName: "Outstanding Settlement",
    icon: Settlement,
    subMenu: [],
    component: OutstandingSettlementPage
  },
  {
    path: "/app/psc-regional/exchange-rate",
    sidebarName: "Exchange Rate",
    navbarName: "Exchange Rate",
    icon: AirlineRouteIcon,
    subMenu: [],
    component: ExchangeRateAirlineView,
  },
  {
    path: "/app/psc-regional/help-center",
    sidebarName: "Help Center",
    navbarName: "Help Center",
    icon: HelpIcon,
    component: HelpCenter,
    subMenu: []
  },
  {
    isNotVisible: true,
    path: "**",
    sidebarName: "Not found",
    navbarName: "Not Found",
    icon: Audit,
    subMenu: [],
    component: NotFound,
    
  }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/regional-supervisor.jsx